import React, { useEffect, useState, useRef } from "react";
import bottiglia from "../../assets/Foto per transizione/P1088502.jpg";

const Sectionhome2 = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(".moving-paragraph");

    if (elements.length > 0) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");
            } /*  else {
                  entry.target.classList.remove("visible");
                } */
          });
        },
        {
          threshold: 0.3, // La visibilità minima dell'elemento per attivare la transizione
        }
      );

      elements.forEach((element) => observer.observe(element));

      return () => observer.disconnect();
    }
  }, []);
  return (
    <div
      id="volti"
      className="bg-[#191919] bg-opacity-60 gap-x-[10em] flex flex-col md:flex-row-reverse items-center justify-center min-h-[60vh] p-16 text-white"
    >
      {/* Right Section - Text */}
      <div className="md:w-1/2 text-center md:text-left flex flex-col items-center md:items-center md:ml-16 moving-paragraph">
        <h1 className="text-4xl md:text-5xl font-bold text-left text-white">
          Volti
        </h1>
        <h2 className="italic text-lg md:text-xl mt-2 text-left font-bold">
          Mario e Alessandro Colonico
        </h2>
        <p className="mt-4 text-xl md:text-2xl max-w-md text-center leading-relaxed">
          <b>Alessandro Colonico:</b> "Contemplare la bellezza di un ulivo mi
          ripaga di tutti gli sforzi che faccio per conservarlo".
        </p>
      </div>

      {/* Left Section - Single Image */}
      <div className="md:w-1/4 flex justify-center mt-6 md:mt-0 moving-paragraph">
        <div className="w-3/4">
          <img
            src={bottiglia}
            alt="Piatto raffinato"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default Sectionhome2;
